import AxiosConfig from '../../../config/AxiosConfig';

const useValidateRefund = () => {
  const validateRefund = async (refundId, profile) => {
    console.log('validateRefund');
    try {
      const response = await AxiosConfig.create('put', `/refunds/${refundId}`)
        .call({
          status: 'VALIDATEDFI',
          actionBy: profile?._id,
          serviceName: 'finance',
          refusedDescription: null,
        })
        .getResponseData();

      return response;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  return { validateRefund };
};

export default useValidateRefund;
